module.exports = __webpack_public_path__ + "static/media/menu-icon.e7281698.svg";